export const botRulesConstants = {
    BOT_RULES_LOADING_SPINNER: 'BOT_RULES_LOADING_SPINNER',
    BOT_RULES_STOP_LOADING_SPINNER: 'BOT_RULES_STOP_LOADING_SPINNER',
    BOT_RULES_RERENDER: 'BOT_RULES_RERENDER',
    BOT_RULES_GET_DATA: 'BOT_RULES_GET_DATA',
    BOT_RULES_DELETE: 'BOT_RULES_DELETE',
    BOT_RULES_UPDATE_CONDITION: 'BOT_RULES_UPDATE_CONDITION',
    BOT_RULES_VALIDATION_ERROR: 'BOT_RULES_VALIDATION_ERROR',
    BOT_RULES_UPDATE_LOGICAL_RELATION: 'BOT_RULES_UPDATE_LOGICAL_RELATION',
    BOT_RULES_UPDATE_NAME: 'BOT_RULES_UPDATE_NAME',
};